import React, { useEffect, useState } from "react";
import { useAppServices } from "../../../hook/services";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "../../../components/LoadingScreen";

const OtherProviders = () => {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const [apps, setApps] = useState([]);
  const [appInstalls, setAppInstalls] = useState([]);
  const getData = async () => {
    const { response } = await AppService.apps.get_apps_with_token({
      query: `companyId=${companyId}&type=Conversation Providers`,
    });
    if (response) {
      setApps(response.data);
      setAppInstalls(response.appInstalls);
    } else {
      setApps([]);
      setAppInstalls([]);
    }
    setProcessing(false);
  };
  useEffect(() => {
    getData();
  }, []);

  const handleAppInstall = (appId) => {
    const url = `https://app.gohighlevel.com/integration/${appId}`;
    window.open(url, "_blank");
  };
  const handleAppView = async (appId) => {
    navigate(`./view/${appId}`);
  };

  if (processing) {
    return <LoadingScreen loadingText={"Loading providers..."} />;
  }
  return (
    <div className="container py-5">
      <h2 className="mb-5 text-center">Conversation Providers</h2>
      <div className="row g-4">
        {apps.map((item) => (
          <div className="col-sm-6 col-md-4 col-lg-3" key={item.id}>
            <div className="card h-100 shadow-sm border-0 py-2">
              <div className="card-body text-center">
                <img
                  src={item.appImage}
                  alt={item.name}
                  style={{ width: "50px", height: "50px" }}
                  className="mb-3"
                />
                <h5 className="card-title">
                  {item.appName} (
                  {
                    appInstalls.filter(
                      (appInstall) => appInstall.appId === item.appId
                    ).length
                  }
                  )
                </h5>
                <p className="card-text text-muted small">
                  {item.shortDescription}
                </p>
              </div>

              {/* Improved Footer */}
              <div className="card-footer bg-transparent border-0">
                <div className="d-flex justify-content-center gap-2">
                  <button
                    className="btn btn-outline-primary btn-sm  px-3"
                    onClick={() => handleAppInstall(item.appId)}
                  >
                    Install
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm  px-3"
                    onClick={() => handleAppView(item.appId)}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherProviders;
